import { BuilderSliceActions, setCookedBuild } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useSaveBuildMutation } from "@builder/store/slices/BuildsApiSlice/buildsApiSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { Build } from "@common/build/types";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useHotkeys } from "react-hotkeys-hook";

const INITIAL_BUILD_IN_LOCAL_STORAGE_KEY = "initialBuild";
const SAVED_BUILD_IN_LOCAL_STORAGE_KEY = "destoredBuild";

export const useRestartOnboard = () => {
    const build = useAppSelector(state => state.builder.build);
    const dispatch = useAppDispatch();
    // const companyId = useAppSelector(state => state.storeData.company?._id || "");
    const companyId = useAppSelector(state => state.builder.build.companyId);
    const [saveBuild] = useSaveBuildMutation();

    // on init, check if there is a build in local storage, if not, save it there:
    useEffect(() => {
        const initialBuild = localStorage.getItem(INITIAL_BUILD_IN_LOCAL_STORAGE_KEY);
        if (!initialBuild && build.pages.length > 0 && build.companyId) {
            localStorage.setItem(INITIAL_BUILD_IN_LOCAL_STORAGE_KEY, JSON.stringify(build));
        }
    }, [build.pages, build.companyId]);

    const resetToBuildandOnboard = async (localstorageKey: string) => {
        const stringifiedBuild = localStorage.getItem(localstorageKey);
        if (!stringifiedBuild) {
            toast.error("Could not restart onboard");
            console.log("No build found in local storage");
            return;
        }
        try {
            if (companyId) {
                const buildToGoBackTo = JSON.parse(stringifiedBuild) as Build;
                buildToGoBackTo.version = build.version;
                dispatch(setCookedBuild(buildToGoBackTo));
                await saveBuild({ companyId, build: buildToGoBackTo }).unwrap();
                dispatch(BuilderSliceActions.updateBuildHistory({ past: [], future: [] }));
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set("onboard", "1");
                window.history.replaceState({}, "", newUrl.toString());
                window.location.reload();
            }
        } catch (error) {
            toast.error("Could not restart onboard");
            console.log("Error parsing build from local storage", error);
        }
    };

    const restartOnboardFromFirstBuild = () => {
        resetToBuildandOnboard(INITIAL_BUILD_IN_LOCAL_STORAGE_KEY);
    };

    const saveBuildToLocalStorage = () => {
        localStorage.setItem(SAVED_BUILD_IN_LOCAL_STORAGE_KEY, JSON.stringify(build));
        toast.success(`Build saved to local storage`);
    };

    const restartOnboardFromSavedBuildOnLocalStorage = () => {
        resetToBuildandOnboard(SAVED_BUILD_IN_LOCAL_STORAGE_KEY);
    };

    useHotkeys(["ctrl+1", "meta+1"], e => {
        e.preventDefault();
        console.log("restarting onboard from first build!");
        restartOnboardFromFirstBuild();
    });

    useHotkeys(["ctrl+2", "meta+2"], e => {
        e.preventDefault();
        console.log("restarting onboard from saved build!");
        saveBuildToLocalStorage();
    });

    useHotkeys(["ctrl+3", "meta+3"], e => {
        e.preventDefault();
        console.log("restarting onboard from saved build!");
        restartOnboardFromSavedBuildOnLocalStorage();
    });
};
